/**
 * 网易七鱼 Web 客服
 * 接入脚本：https://qiyukf.com/script/{appKey}.js
 */
import {
	qiyuAppKey
} from '@/utils/webconfig.js';
import {
	getAccountInfo
} from '@/utils/localdatas';

let readyPromise = null;

/**
 * 加载并初始化七鱼 SDK；hidden=1 隐藏默认浮标，改用站内入口
 */
export function initQiyu(options = {}) {
	if (typeof window === 'undefined') {
		return Promise.resolve(null);
	}
	// 已就绪则直接返回
	if (window.__qiyuReady && typeof window.ysf === 'function') {
		return Promise.resolve(window.ysf);
	}
	if (readyPromise) {
		return readyPromise;
	}

	const appKey = options.appKey || qiyuAppKey;
	const hidden = options.hidden !== undefined ? options.hidden : 1; // 1=隐藏官方默认入口

	readyPromise = new Promise((resolve, reject) => {
		// 队列桩：脚本加载前也能缓存调用
		window.ysf = window.ysf || function() {
			(window.ysf.a = window.ysf.a || []).push(arguments);
		};

		const script = document.createElement('script');
		script.async = true;
		script.src = 'https://qiyukf.com/script/' + appKey + '.js?hidden=' + hidden;
		script.onload = function() {
			window.__qiyuReady = true;
			var settled = false;
			function done() {
				if (settled) return;
				settled = true;
				resolve(window.ysf);
			}
			if (typeof window.ysf === 'function') {
				window.ysf('onready', done); // SDK 就绪回调
				setTimeout(done, 2000); // 兜底：无 onready 时
			} else {
				done();
			}
		};
		script.onerror = function() {
			readyPromise = null;
			reject(new Error('七鱼 SDK 加载失败'));
		};
		document.body.appendChild(script);
	});

	return readyPromise;
}

/**
 * 打开七鱼会话；已登录则带上访客资料
 */
export function openQiyuChat(extraConfig) {
	return initQiyu().then(function(ysf) {
		if (!ysf) {
			return;
		}
		const account = getAccountInfo();
		const config = Object.assign({}, buildVisitorConfig(account), extraConfig || {});
		if (config.uid || config.data || config.name || config.mobile) {
			ysf('config', config); // 上报访客身份
		}
		ysf('open'); // 打开会话窗
	}).catch(function(err) {
		console.error(err);
		// SDK 失败时降级到七鱼 H5 会话页
		window.open('https://qiyukf.com/client?k=' + qiyuAppKey, '_blank');
	});
}

/** 从本站账号拼七鱼访客 config */
function buildVisitorConfig(account) {
	if (!account) {
		return {};
	}
	const uid = account.Account || account.UserCode || account.PersonCode || account.Mobile || '';
	const name = account.Name || account.NickName || '';
	const mobile = account.Mobile || '';
	const email = account.Email || '';
	const data = [];
	if (name) {
		data.push({
			key: 'real_name',
			value: name
		});
	}
	if (mobile) {
		data.push({
			key: 'mobile_phone',
			value: mobile
		});
	}
	if (email) {
		data.push({
			key: 'email',
			value: email
		});
	}
	if (uid) {
		data.push({
			index: 0,
			key: 'account',
			label: '账号',
			value: String(uid)
		});
	}
	const config = {};
	if (uid) {
		config.uid = String(uid);
	}
	if (name) {
		config.name = name;
	}
	if (mobile) {
		config.mobile = mobile;
	}
	if (email) {
		config.email = email;
	}
	if (data.length) {
		config.data = JSON.stringify(data);
	}
	return config;
}
